export type SocialComponentLocation = 'RECORD' | 'PLATFORM';

export enum ShareType {
  FACEBOOK = 'facebook',
  X = 'x',
  LINKEDIN = 'linkedin',
  WHATSAPP = 'whatsapp',
  EMAIL = 'email',
  QQ = 'qq',
  WEIBO = 'weibo',
  WEBCHAT = 'webchat',
}

export const defaultSocialIcons = [
  ShareType.FACEBOOK,
  ShareType.X,
  ShareType.LINKEDIN,
  ShareType.WHATSAPP,
  ShareType.EMAIL,
];

export interface ShareParams {
  url?: string;
  title?: string;
  description?: string;
  image?: string;
  tags?: string;
  via?: string;
  appId?: string;
  redirectUrl?: string;
}

export interface SocialButtonConfig {
  type: ShareType;
  text: string;
  ariaLabel: string;
  iconLigature: string;
  shareLinks: ShareLinks;
  paramKeys: ShareParams;
}

export interface ShareLinks {
  generic?: string;
  android?: string;
  ios?: string;
}

const X: SocialButtonConfig = {
  type: ShareType.X,
  text: 'social.network.x',
  ariaLabel: 'social.button.label.x',
  iconLigature: 'social_x',
  shareLinks: {
    generic: 'https://twitter.com/intent/tweet?',
  },
  paramKeys: {
    url: 'url',
    description: 'text',
    tags: 'hashtags',
    via: 'via',
  },
};

const FACEBOOK: SocialButtonConfig = {
  type: ShareType.FACEBOOK,
  text: 'social.network.facebook',
  ariaLabel: 'social.button.label.facebook',
  iconLigature: 'social_facebook',
  shareLinks: {
    generic: 'https://www.facebook.com/sharer/sharer.php?',
  },
  paramKeys: {
    url: 'u',
  },
};

const LINKEDIN: SocialButtonConfig = {
  type: ShareType.LINKEDIN,
  text: 'social.network.linkedin',
  ariaLabel: 'social.button.label.linkedin',
  iconLigature: 'social_linkedin',
  shareLinks: {
    generic: 'https://www.linkedin.com/shareArticle?',
  },
  paramKeys: {
    url: 'url',
    title: 'title',
    description: 'summary',
  },
};

const WHATSAPP: SocialButtonConfig = {
  type: ShareType.WHATSAPP,
  text: 'social.network.whatsapp',
  ariaLabel: 'social.button.label.whatsapp',
  iconLigature: 'social_whatsapp',
  shareLinks: {
    generic: 'https://wa.me/?',
    android: 'whatsapp://send?',
    ios: 'https://wa.me/?',
  },
  paramKeys: {
    url: 'text',
  },
};

const EMAIL: SocialButtonConfig = {
  type: ShareType.EMAIL,
  text: 'social.network.email',
  ariaLabel: 'social.button.label.email',
  iconLigature: 'email',
  shareLinks: {
    generic: 'mailto:?',
  },
  paramKeys: {
    title: 'subject',
    description: 'body',
  },
};

const QQ: SocialButtonConfig = {
  type: ShareType.QQ,
  text: 'social.network.qq',
  ariaLabel: 'social.button.label.qq',
  iconLigature: 'qq',
  shareLinks: {
    generic: 'https://connect.qq.com/widget/shareqq/index.html?',
  },
  paramKeys: {
    url: 'url',
    title: 'title',
    description: 'desc',
  },
};

const WEIBO: SocialButtonConfig = {
  type: ShareType.WEIBO,
  text: 'social.network.weibo',
  ariaLabel: 'social.button.label.weibo',
  iconLigature: 'weibo',
  shareLinks: {
    generic: 'https://service.weibo.com/share/share.php?',
  },
  paramKeys: {
    url: 'url',
    title: 'title',
  },
};

const WEBCHAT: SocialButtonConfig = {
  type: ShareType.WEBCHAT,
  text: 'social.network.webchat',
  ariaLabel: 'social.button.label.webchat',
  iconLigature: 'webchat',
  shareLinks: {
    generic: 'https://api.qrserver.com/v1/create-qr-code/?',
  },
  paramKeys: {
    url: 'data',
  },
};

export const shareTypeToConfig = new Map<ShareType, SocialButtonConfig>([
  [ShareType.X, X],
  [ShareType.FACEBOOK, FACEBOOK],
  [ShareType.LINKEDIN, LINKEDIN],
  [ShareType.EMAIL, EMAIL],
  [ShareType.WHATSAPP, WHATSAPP],
  [ShareType.QQ, QQ],
  [ShareType.WEIBO, WEIBO],
  [ShareType.WEBCHAT, WEBCHAT],
]);
